import React from "react";
import { StyleSheet } from "react-native";
import Svg, { Defs, RadialGradient, Rect, Stop } from "react-native-svg";
import { defaultTheme } from "../providers/ThemeProvider";

export const BackgroundGradient = (props?: {
  background?: string;
  accent?: string;
}) => (
  <Svg height="100%" width="100%" style={StyleSheet.absoluteFillObject}>
    <Defs>
      <RadialGradient id="grad" cx="75%" cy="75%" rx="50%" ry="60%">
        <Stop
          offset="0"
          stopColor={props?.accent ?? defaultTheme.accent}
          stopOpacity="1"
        />
        <Stop
          offset="1"
          stopColor={props?.background ?? defaultTheme.background}
          stopOpacity="1"
        />
      </RadialGradient>
    </Defs>
    <Rect width="100%" height="100%" fill="url(#grad)" />
  </Svg>
);
